import { AnalyticsEvent, SendAnalyticsEvent } from 'shared/entities/analytics';
import { OnboardingAfterPendingState } from 'shared/entities/onboarding';
import { SessionStorageKey } from 'shared/entities/sessionStorage';
import { getElapsedSeconds } from 'shared/utils/analytics/elapsedSeconds';
import { sessionStorageHandler } from 'stores/sessionStorageHandler';

const CHANNEL_SS_KEY = SessionStorageKey.onboardingChannelCreateStarting;
const SCENARIO_SS_KEY = SessionStorageKey.onboardingScenarioCreateStarting;

const readAfterOnboardingPending = (
  key: SessionStorageKey
): OnboardingAfterPendingState | null => {
  const raw = sessionStorageHandler.getItem(key);

  if (!raw) {
    return null;
  }

  try {
    const state = JSON.parse(raw) as OnboardingAfterPendingState;

    if (typeof state.startedAt !== 'number') {
      return null;
    }

    return state;
  } catch {
    return null;
  }
};

const writeAfterOnboardingPending = (
  key: SessionStorageKey,
  state: OnboardingAfterPendingState
): void => {
  sessionStorageHandler.setItem(key, JSON.stringify(state));
};

export const setChannelAfterOnboardingPending = (): void => {
  writeAfterOnboardingPending(CHANNEL_SS_KEY, { startedAt: Date.now() });
};

export const setScenarioAfterOnboardingPending = (): void => {
  writeAfterOnboardingPending(SCENARIO_SS_KEY, { startedAt: Date.now() });
};

export const clearChannelAfterOnboardingPending = (): void => {
  sessionStorageHandler.remove(CHANNEL_SS_KEY);
};

export const clearScenarioAfterOnboardingPending = (): void => {
  sessionStorageHandler.remove(SCENARIO_SS_KEY);
};

export const trySendChannelAfterOnboarding = (
  sendEvent: SendAnalyticsEvent
): boolean => {
  const pending = readAfterOnboardingPending(CHANNEL_SS_KEY);

  if (!pending) {
    return false;
  }

  sendEvent(AnalyticsEvent.channelCreationAfterOnboarding, {
    elapsed_seconds: getElapsedSeconds(pending.startedAt)
  });
  clearChannelAfterOnboardingPending();
  return true;
};

export const trySendScenarioAfterOnboarding = (
  sendEvent: SendAnalyticsEvent
): boolean => {
  const pending = readAfterOnboardingPending(SCENARIO_SS_KEY);

  if (!pending) {
    return false;
  }

  sendEvent(AnalyticsEvent.scenarioCreationAfterOnboarding, {
    elapsed_seconds: getElapsedSeconds(pending.startedAt)
  });
  clearScenarioAfterOnboardingPending();
  return true;
};
